import {useTheme, VStack} from '@chakra-ui/react'
import Image from 'next/image'
import User from '../../public/assets/user_gradient.svg'

const UserImage = () => {
  const theme = useTheme()
  return (
    <VStack
      minWidth={[16, null, 20]}
      minHeight={[16, null, 20]}
      width={[16, null, 20]}
      height={[16, null, 20]}
      borderRadius='infinite'
      background={theme.colors.brand.white}
      justify='center'>
      <Image width={27} height={30} src={User} alt='user' />
    </VStack>
  )
}

export default UserImage
